import { map } from 'rxjs/operators';
import APIv4ResponseProcessor from '../../../Shared/Infrastructure/Http/APIv4ResponsePipeProcessor';
import APIv4GetCustomerInfoResponseAdapter from '../Adapters/APIv4GetCustomerInfoResponseAdapter';
import APIv4RegisterResponseAdapter from '../Adapters/APIv4RegisterResponseAdapter';
import APIv4UpdateCustomerInfoResponseAdapter from '../Adapters/APIv4UpdateCustomerInfoResponseAdapter';
import CUSTOMER_EXCEPTIONS from '../Exceptions/APIv4CustomerExceptionMap';
const ENDPOINT_REGISTER = '/customers';
const ENDPOINT_GET_CUSTOMER_INFO = '/customer/me';
const ENDPOINT_UPDATE_CUSTOMER_INFO = '/customer/me';
const ENDPOINT_FORGOT_PASSWORD = '/support/send_forgot_password_email';
const ENDPOINT_RESET_PASSWORD = '/support/reset_password';
const ENDPOINT_LOGIN = '/oauth/access_token';
const ENDPOINT_SUBSCRIBE_NEWSLETTER = '/optins';
class APIv4CustomerRepository {
  constructor(context, httpClient) {
    this.context = context;
    this.httpClient = httpClient;
    this.postHeaders = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    };
    this.oauthEndpoint = `${this.context.baseUrl}${ENDPOINT_LOGIN}`;
  }
  findByCustomer(username, password) {
    const credentials = JSON.stringify({
      clientID: this.context.clientId,
      grant_type: 'password',
      rand: '',
      user_credential: password,
      userID: username
    });
    return this.httpClient.post(this.oauthEndpoint, `request_data=${credentials}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    }).pipe(map(({
      response_data
    }) => ({
      accessToken: response_data.access_token,
      expiresIn: response_data.expires_in
    })));
  }
  registerCustomer(customer, password, accessToken) {
    const url = `${this.context.baseUrl}${ENDPOINT_REGISTER}?access_token=${accessToken}`;
    const userToStringify = {
      type: customer.type,
      email: customer.email,
      password: password,
      username: customer.email,
      subscribe_newsletter: customer.newsletter ?? undefined,
      subscribe_promotion: customer.promotions ?? undefined,
      info: {
        firstname: customer.firstName,
        lastname: customer.lastName,
        // FIXME: APIv4 requires genre to be send
        title: customer.genre || 'Mr',
        country: customer.country || 'ES',
        // FIXME: check how APIv4 accepts the date of birth
        dayOfBirth: customer.dayOfBirth,
        monthOfBirth: customer.monthOfBirth,
        yearOfBirth: customer.yearOfBirth
      }
    };
    const user = JSON.stringify(userToStringify);
    return this.httpClient.post(url, `request_data=${user}`, this.postHeaders).pipe(APIv4ResponseProcessor.handle(CUSTOMER_EXCEPTIONS), map(v4Response => APIv4RegisterResponseAdapter.toCustomerCredentials(v4Response)));
  }
  getCustomer(accessToken) {
    // TODO this url SHOULD come from a context variable (maybe this.contenxt.baseUrl)
    const url = `${this.context.baseUrl}${ENDPOINT_GET_CUSTOMER_INFO}?access_token=${accessToken}`;
    const request = this.httpClient.get(url);
    return request.pipe(APIv4ResponseProcessor.handle(CUSTOMER_EXCEPTIONS), map(v4Response => APIv4GetCustomerInfoResponseAdapter.toGetCustomerInfoResponse(v4Response)));
  }
  // TODO: check promotions from API (property/field name for promotions)
  updateCustomer(customer, accessToken) {
    // Using the user/me endpoint SHOULD work but access_token SHOULD NOT be used as a query string, instead add it on the body payload
    const url = `${this.context.baseUrl}${ENDPOINT_UPDATE_CUSTOMER_INFO}?access_token=${accessToken}`;
    const customerJson = JSON.stringify({
      customer: customer
    });
    const body = `request_data=${customerJson}`;
    const request = this.httpClient.put(url, body, this.postHeaders);
    return request.pipe(APIv4ResponseProcessor.handle(CUSTOMER_EXCEPTIONS), map(v4Response => APIv4UpdateCustomerInfoResponseAdapter.toUpdateCustomerInfoResponse(v4Response)));
  }
  forgotPassword(email, lang, redirectURL) {
    const url = `${this.context.baseUrl}${ENDPOINT_FORGOT_PASSWORD}`;
    const customer = JSON.stringify({
      email: email,
      projectID: this.context.projectId,
      lang: lang,
      redirectURL: redirectURL
    });
    return this.httpClient.post(url, `request_data=${customer}`, this.postHeaders).pipe(APIv4ResponseProcessor.handle(CUSTOMER_EXCEPTIONS), map(v4Response => APIv4RegisterResponseAdapter.toForgotPasswordResponse(v4Response)));
  }
  // TODO: should resetPassword method send actual pass and new pass to API for verifying?
  resetPassword(token, accessToken, customerId, password) {
    const url = `${this.context.baseUrl}${ENDPOINT_RESET_PASSWORD}?access_token=${accessToken}`;
    const customerJson = JSON.stringify({
      customerID: customerId,
      projectID: this.context.projectId,
      token: token,
      password: password
    });
    return this.httpClient.post(url, `request_data=${customerJson}`, this.postHeaders).pipe(APIv4ResponseProcessor.handle(CUSTOMER_EXCEPTIONS), map(v4Response => APIv4RegisterResponseAdapter.toResetPasswordResponse(v4Response)));
  }
  subscribeToNewsletter(email, subscribe_newsletter, subscribe_promotion, accessToken, extra) {
    const url = `${this.context.baseUrl}${ENDPOINT_SUBSCRIBE_NEWSLETTER}?access_token=${accessToken}`;
    const host = `${this.context.baseUrl}`;
    const requestData = JSON.stringify({
      email,
      subscribe_newsletter,
      subscribe_promotion,
      host,
      extra: extra
    });
    return this.httpClient.post(url, `request_data=${requestData}`, this.postHeaders).pipe(APIv4ResponseProcessor.handle(CUSTOMER_EXCEPTIONS), map(v4Response => APIv4RegisterResponseAdapter.toSubscribeNewsletterResponse(v4Response)));
  }
}

export { APIv4CustomerRepository as default };